import type { ThemeTokens } from '@/shared/ui/theme/tokens';

interface BackButtonProps {
  T: ThemeTokens;
  onClick: () => void;
  label?: string;
}

export function BackButton({ T, onClick, label = 'Volver' }: BackButtonProps) {
  return (
    <button
      onClick={onClick}
      style={{
        background: 'transparent',
        border: `1px solid ${T.border}`,
        borderRadius: 8,
        padding: '7px 12px',
        cursor: 'pointer',
        color: T.text,
        fontFamily: 'inherit',
        display: 'flex',
        alignItems: 'center',
        gap: 5,
        fontSize: 11,
        fontWeight: 600,
        zIndex: 1,
      }}
    >
      <svg width={11} height={11} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
        <polyline points="15 18 9 12 15 6" />
      </svg>
      {label}
    </button>
  );
}
